module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (!_vm.$teras.appReady),
      expression: "!$teras.appReady",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "id": "app"
    }
  }, [_c('site-header'), _vm._v(" "), (_vm.$teras.appReady) ? _c('div', {
    staticClass: "container",
    staticStyle: {
      "background": "#ffffff",
      "padding": "62px 20px 0 20px"
    }
  }, [_c('div', {
    staticClass: "evento-title yo-color-primary"
  }, [_vm._v(_vm._s(_vm.$teras.bvent.titolo) + ": ABSTRACT")])]) : _vm._e(), _vm._v(" "), (_vm.$teras.appReady) ? _c('div', {
    staticClass: "row container",
    staticStyle: {
      "background": "#ffffff",
      "padding": "0 20px 60px 20px"
    }
  }, [_c('div', {
    staticClass: "col s12",
    attrs: {
      "id": "main"
    }
  }, [_c('router-view', {
    attrs: {
      "name": "main"
    }
  }), _vm._v(" "), (_vm.$teras.chiuso) ? _c('h4', [_vm._v("Siamo spiacenti il gestionale è chiuso. ")]) : _vm._e(), _vm._v(" "), (_vm.$teras.noabstract) ? _c('h4', [_vm._v("Abstract non trovato.")]) : _vm._e(), _vm._v(" "), (_vm.$teras.noevento) ? _c('h4', [_vm._v("Evento non trovato.")]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.$teras.appReady) ? _c('site-footer') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74fa2cf8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 612
// module chunks = 2